<template>
  <AvalCalendar
    v-model="dateRange"
    :locale="activeLanguage"
  />
</template>

<script setup>
import { computed, inject, defineEmits } from "vue";
import { useLK } from "@/controllerLK/LKstore";
import { startOfDayUTC3, endOfDayUTC3 } from "@/tools/date-time-tools";

const LKStore = useLK();
const activeLanguage = computed(() => {
  // user.language может быть пустой строкой (новый /users/me не всегда отдаёт
  // язык) — пустой locale ломает Date.toLocaleDateString с RangeError.
  const lang = LKStore.user?.language;
  return (typeof lang === "string" && lang.length > 0) ? lang.toLowerCase() : "ru";
});

const selectedDateFilter = inject("selectedDateFilter");
const emit = defineEmits(["update-filter"]);

const dateRange = computed({
  get() {
    // Берём unix-время (сек) из инъекта и превращаем в Date
    return [
      new Date(selectedDateFilter.value.dateFrom * 1000),
      new Date(selectedDateFilter.value.dateTo   * 1000)
    ];
  },
  set([ startDate, endDate ]) {
    // Возвращаем в секунды и нормализуем к UTC+3

    if (startDate) {
      selectedDateFilter.value.dateFrom = startOfDayUTC3(Math.floor(startDate.getTime() / 1000));
    }

    // Если конечная дата не передана, устанавливаем сегодняшний день.
    if (endDate) {
      selectedDateFilter.value.dateTo = endOfDayUTC3(Math.floor(endDate.getTime() / 1000));
    } else {
      selectedDateFilter.value.dateTo = endOfDayUTC3(Math.floor(new Date().getTime() / 1000));
    }

    emit("update-filter");
  }
});
</script>
